import {Routes} from '@angular/router';
import {HomeComponent} from "./home/home.component";

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'daily',
    loadComponent: () => import('./daily/daily.component').then(m => m.DailyComponent)
  },
  {
    path: 'lobby',
    loadComponent: () => import('./game/game-layout/game-layout.component').then(m => m.GameLayoutComponent),
    children: [
      {
        path: ':roomId',
        loadComponent: () => import('./lobby/lobby/lobby.component').then(m => m.LobbyComponent)
      },
      {
        path: ':roomId/play',
        loadComponent: () => import('./game/game.component').then(m => m.GameComponent)
      },
    ]
  },
  {
    path: 'host/:roomId/play',
    loadComponent: () => import('./host/host-play/host-play.component').then(m => m.HostPlayComponent)
  },
  {
    path: 'host/:roomId',
    loadComponent: () => import('./host/host.component').then(m => m.HostComponent)
  },
  {
    path: 'host',
    loadComponent: () => import('./host/host.component').then(m => m.HostComponent)
  },
  {
    path: 'admin/manual-verification',
    loadComponent: () => import('./admin/manual-verification/manual-verification.component').then(m => m.ManualVerificationComponent)
  },
  {
    path: 'admin/proposal',
    loadComponent: () => import('./admin/proposal/proposal.component').then(m => m.ProposalComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
